<template>
  <div class="border-4 m-6" :class="{ 'border-green-900': isOpen, 'border-red-900': !isOpen }">
    <div class="flex flex-row p-2 text-white font-medium" :class="{ 'bg-green-900': isOpen, 'bg-red-900': !isOpen }" @click="isOpen = !isOpen">
      <svg fill="currentColor" viewBox="0 0 20 20" class="w-5 h-5 mr-2">
        <path
          :class="{ 'rotate-180': !isOpen }"
          class="transition duration-300 ease-in-out origin-center transform"
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
      <span>{{ title }}</span>
    </div>
    <transition
      enter-class="h-0 opacity-0"
      enter-active-class="transition duration-1000 ease-out transform"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition duration-1000 ease-in transform"
      leave-to-class="h-0 opacity-0"
    >
      <pre v-show="isOpen" class="p-2 overflow-hidden bg-gray-400">{{ JSON.stringify(value, null, 2) }}</pre>
    </transition>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  value: { type: [Object, String, Array, Number, Boolean], required: false, default: null },
  title: { type: String, required: false, default: 'Dump' },
  open: { type: Boolean, required: false, default: true },
})

const isOpen = ref(props.open)
</script>
